import { useEffect, useState, useRef } from "react";
import { Button, Form, Alert, Row, Col, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import UcrtValidation from "../../../hooks/UcrtValidation";
import { createUpdateUcrt } from "../../../store/actions/ucrtsAction";
import { resetPopup } from "../../../store/reducerSlice/ucrts";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import moment from "moment";
import { createUpdateImc } from "../../../store/actions/imcAction";

const formElements = [
  {
    key: "ward",
    label: "Ward",
    placeHolder: "Select ward",
    type: "text",
    disabled: true,
    // options: [],
    // required: true,
  },

  {
    key: "bedTypes",
    label: "Bed Type",
    placeHolder: "Enter Bed Type",
    type: "text",
    disabled: true,
    // required: true,
  },
  {
    key: "provider",
    label: "Provider",
    placeHolder: "Select provider",
    type: "text",
    disabled: true,
    // options: [],
  },
  {
    key: "totalBeds",
    label: "Total Beds",
    placeHolder: "0",
    type: "text",
     disabled: true,
  },
  {
    key: "occupiedBeds",
    label: "Total Occupied/ Allocated Beds",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "escalationBeds",
    label: "Escalations Beds in use",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "closedBeds",
    label: "Closed Beds",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "availableBeds",
    label: "Available Beds",
    placeHolder: "0",
    type: "text",
    disabled: true,
  },
  {
    key: "patientCriteria",
    label: "Patients not meeting Criteria to Reside",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "confirmedAdmissionsToday",
    label: "Confirmed Admissions (Today)",
    placeHolder: "0",
    type: "text",
    size:6
  },
  {
    key: "confirmedAdmissionsTomorrow",
    label: "Confirmed Admissions (Tomorrow)",
    placeHolder: "0",
    type: "text",
    size:6
  },
  {
    key: "confirmedDischargesToday",
    label: "Confirmed Discharges (Today)",
    placeHolder: "0",
    type: "text",
    size:6
  },

  {
    key: "pendingDischargesTomorrow",
    label: "Pending Discharges (Tomorrow)",
    placeHolder: "0",
    type: "text",
    size:6
  },
];

const ManageImc = (props) => {
  const { selectRow } = props;
  const adminDetail = props.adminDetail;
  // Accessing wardTypes from adminDetail
  const wardTypes = adminDetail?.wardTypes;
  const locationTypes = adminDetail?.locations;
  const [isShow, setIsShow] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [locationOptions, setLocationOptions] = useState(null);
  const validateLargeAmount = (event) => {
    const input = event.target.value;
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow backspace, delete, and navigation keys
    if (
      (event.key >= "0" && event.key <= "9") ||
      event.key === "Backspace" ||
      event.key === "Delete" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      if (input === "NA") {
        // If the default value is 'NA', clear the text field
        event.target.value = "";
      }
      return;
    } else {
      // Clear the input if a non-numeric value is entered
      event.preventDefault();
      if (input === "NA") {
        // If the default value is 'NA', clear the text field
        event.target.value = "";
      }
    }

    // Check if the input only contains digits
    const isValidFormat = /^\d*$/.test(input + keyValue);

    if (!isValidFormat) {
      event.preventDefault();
    }
  };
  const [imcDetail, setImcDetail] = useState({
    ward: null,
    bedTypes: null,
    provider: null,
    totalBeds: null,
    occupiedBeds: null,
    escalationBeds: null,
    closedBeds: null,
    availableBeds: null,
    patientCriteria: null,
    confirmedAdmissionsToday: null,
    confirmedAdmissionsTomorrow: null,
    confirmedDischargesToday: null,
    pendingDischargesTomorrow: null,
  });
  const { locations } = useSelector((state) => {
    return state.locations;
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    UcrtValidation({
      // location: imcDetail?.location,
      // name: imcDetail?.name ? imcDetail?.name : null,
      // type: imcDetail?.type,
      // numberOfBeds: imcDetail?.numberOfBeds
      //   ? imcDetail?.numberOfBeds?.toString()
      //   : null,
    });

  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.ucrts);
  // fetch location list
  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
  }, []);
  // set location list
  useEffect(() => {
    if (Array.isArray(locations)) {
      let arr = locations.map((x) => {
        return { _id: x._id, name: x?.name };
      });
      setLocationOptions(arr);
    }
  }, [locations]);

  // set details page
  useEffect(() => {
    if (selectRow === null) {
      setImcDetail({
        ward: null,
        bedTypes: null,
        provider: null,
        totalBeds: null,
        occupiedBeds: null,
        escalationBeds: null,
        closedBeds: null,
        availableBeds: null,
        patientCriteria: null,
        confirmedAdmissionsToday: null,
        confirmedAdmissionsTomorrow: null,
        confirmedDischargesToday: null,
        pendingDischargesTomorrow: null,
      });
    } else {
      setImcDetail({
        imcId: selectRow?._id,
        ward: selectRow?.ward,
        bedTypes: selectRow?.bedTypes,
        provider: selectRow?.provider,
        totalBeds: selectRow?.totalBeds,
        occupiedBeds: selectRow?.occupiedBeds,
        escalationBeds: selectRow?.escalationBeds,
        closedBeds: selectRow?.closedBeds,
        availableBeds: selectRow?.availableBeds,
        patientCriteria: selectRow?.patientCriteria,
        confirmedAdmissionsToday: selectRow?.confirmedAdmissionsToday,
        confirmedAdmissionsTomorrow: selectRow?.confirmedAdmissionsTomorrow,
        confirmedDischargesToday: selectRow?.confirmedDischargesToday,
        pendingDischargesTomorrow: selectRow?.pendingDischargesTomorrow,
      });
    }
  }, [selectRow]);
  // Set ward name
  useEffect(() => {
    if (selectRow === null) {
      let loc =
        locationOptions &&
        locationOptions.find((opt) => opt._id === imcDetail?.location);
      setImcDetail({
        ...imcDetail,

        ucrtMse:
          (imcDetail?.location ? loc?.name : "Geography") +
          " " +
          (imcDetail?.type ? imcDetail?.type : "UCRT"),
      });
    }
  }, [imcDetail?.location, imcDetail?.type]);

  const submitHandler = (e) => {
    e.preventDefault();
    // checkValidator();
    setIsActionCalled(true);
  };
  // formData useEffects
  useEffect(() => {
    setIsUploading(true);
    //const loc =imcDetail?.location?JSON.parse(imcDetail?.location):null
    let formData = {
      imcId: selectRow?._id,
      ward: imcDetail?.ward,
      bedTypes: imcDetail?.bedTypes,
      provider: imcDetail?.provider,
      totalBeds: imcDetail?.totalBeds,
      occupiedBeds: imcDetail?.occupiedBeds,
      escalationBeds: imcDetail?.escalationBeds,
      closedBeds: imcDetail?.closedBeds,
      availableBeds: imcDetail?.availableBeds,
      patientCriteria: imcDetail?.patientCriteria,
      confirmedAdmissionsToday: imcDetail?.confirmedAdmissionsToday,
      confirmedAdmissionsTomorrow: imcDetail?.confirmedAdmissionsTomorrow,
      confirmedDischargesToday: imcDetail?.confirmedDischargesToday,
      pendingDischargesTomorrow: imcDetail?.pendingDischargesTomorrow,
    };
    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateImc(formData)).then(({ payload }) => {
        if (payload.success) {
          setIsUploading(true);
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  useEffect(() => {
    if (apiError) {
      setTimeout(() => {
        dispatch(resetPopup());
      }, 3000);
    }
  }, [apiError]);

useEffect(() => {
  setImcDetail(prev => {
    const { totalBeds, occupiedBeds, escalationBeds, closedBeds } = prev;

    if (totalBeds || occupiedBeds || escalationBeds || closedBeds) {
      let calculated =
        parseInt(totalBeds || 0) -
        (parseInt(occupiedBeds || 0) -
          parseInt(escalationBeds || 0) +
          parseInt(closedBeds || 0));

      // 🚫 Never allow negative available beds
      const availableBeds = Math.max(0, calculated);

      return { ...prev, availableBeds };
    }

    return { ...prev, availableBeds: null };
  });
}, [
  imcDetail?.totalBeds,
  imcDetail?.occupiedBeds,
  imcDetail?.escalationBeds,
  imcDetail?.closedBeds
]);


  const hideHandler = () => {
    setIsActionCalled(false);
    resetAllValidator();
    props.onHide();
    if (selectRow === null) {
      setImcDetail({
        ward: null,
        bedTypes: null,
        provider: null,
        totalBeds: null,
        occupiedBeds: null,
        escalationBeds: null,
        closedBeds: null,
        availableBeds: null,
        patientCriteria: null,
        confirmedAdmissionsToday: null,
        confirmedAdmissionsTomorrow: null,
        confirmedDischargesToday: null,
        pendingDischargesTomorrow: null,
      });
    } else {
      setImcDetail({
        imcId: selectRow?._id,
        ward: selectRow?.ward,
        bedTypes: selectRow?.bedTypes,
        provider: selectRow?.provider,
        totalBeds: selectRow?.totalBeds,
        occupiedBeds: selectRow?.occupiedBeds,
        escalationBeds: selectRow?.escalationBeds,
        closedBeds: selectRow?.closedBeds,
        availableBeds: selectRow?.availableBeds,
        patientCriteria: selectRow?.patientCriteria,
        confirmedAdmissionsToday: selectRow?.confirmedAdmissionsToday,
        confirmedAdmissionsTomorrow: selectRow?.confirmedAdmissionsTomorrow,
        confirmedDischargesToday: selectRow?.confirmedDischargesToday,
        pendingDischargesTomorrow: selectRow?.pendingDischargesTomorrow,
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="xl"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectRow ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}

        <Row>
          {formElements.map((element, i) => {
            return (
              (!selectRow ||
                element.key !== "password" ||
                element.type !== "text1") && (
                <Col xs={12} md={element.size ? element.size : 4}>
                  <Form.Group
                    className="mb-4"
                    controlId="formBasicEmail"
                    key={i}
                  >
                    {element.type !== "text1" && (
                      <Form.Label>
                        {element.label}{" "}
                        {element.required && (
                          <span className="required">*</span>
                        )}
                      </Form.Label>
                    )}

                    {element.type === "select" ? (
                      <>
                        <Form.Select
                          disabled={
                            element.key === "location" && selectRow
                              ? true
                              : false
                          }
                          name={element.key}
                          //value={element.key=='location'? JSON.parse(imcDetail?.location) :imcDetail[element.key]}
                          value={imcDetail[element.key]}
                          onChange={(e) => {
                            setImcDetail({
                              ...imcDetail,
                              [element.key]: e.target.value,
                            });
                            resetValidator(e.target.name);
                          }}
                          isInvalid={error && error[element.key]}
                        >
                          <option
                            style={{ display: "none", padding: "2px 0px" }}
                            value=""
                          >
                            Select
                          </option>
                          {element.key === "location" && locationTypes
                            ? locationTypes.map((item) => (
                                // <option value={JSON.stringify(item)}>{item.name}</option>
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item._id}
                                >
                                  {item.name}
                                </option>
                              ))
                            : element.key === "location" && locationOptions
                            ? locationOptions.map((item) => (
                                // <option value={JSON.stringify(item)}>{item.name}</option>
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item._id}
                                >
                                  {item.name}
                                </option>
                              ))
                            : element.key === "type" && wardTypes
                            ? wardTypes.map((item) => (
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item}
                                >
                                  {item}
                                </option>
                              ))
                            : element.options.map((item) => (
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item}
                                >
                                  {" "}
                                  {item}{" "}
                                </option>
                              ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {error && error[element.key]}
                        </Form.Control.Feedback>
                      </>
                    ) : (
                      element.type !== "text1" && (
                        <>
                          <Form.Control
                            style={{
                              display: element.key ? "display" : "none",
                            }}
                            disabled={
                              element?.disabled
                                ? true
                                : element.key === "ucrtMse" ||
                                  element.key === "locationName"
                                ? true
                                : false
                            }
                            type={element.type}
                            name={element.key}
                            placeholder={element.placeHolder}
                            value={
                              imcDetail && imcDetail?.action
                                ? imcDetail[element.key] ||
                                  imcDetail.action?.[element.key]
                                : imcDetail[element.key]
                            }
                            maxLength={element.key === "anyChanges" ? 150 : 10}
                            onChange={(e) => {
                              setImcDetail({
                                ...imcDetail,
                                [element.key]: e.target.value,
                              });
                            }}
                            onKeyPress={
                              element.key === "anyChanges"
                                ? ""
                                : validateLargeAmount
                            }
                            isInvalid={error && error[element.key]}
                          />
                          <Form.Control.Feedback type="invalid">
                            {error && error[element.key]}
                          </Form.Control.Feedback>
                        </>
                      )
                    )}
                  </Form.Group>
                </Col>
              )
            );
          })}
        </Row>

        {isActionCalled && (
          <ApiResponsePopup
            {...{
              hideHandlerRes,
              isRecordUpdated: isShow,
              title: "Manage IMC/Stroke",
              successMsg: successMessage,
              errorRes: apiError?.message,
            }}
          />
        )}
      </Popup>
    </>
  );
};

export default ManageImc;
